<template>
  <button
    v-bind:id="name"
    :class="classObject"
    v-on:click="switchButton"
  >
    {{$t(name)}}
  </button>
</template>

<script>
export default {
  data() {
    return {
      isActive: false
    };
  },
  props: {
    name: {
      required: true,
      type: String
    }
  },
  computed: {
    classObject: function() {
      return {
        active: this.isActive,
        button: true,
      };
    }
  },
  methods: {
    switchButton() {
      this.isActive = !this.isActive;
      this.$emit("status", this.isActive);
    }
  }
};
</script>

<style scoped lang="scss">
.button {
  display: block;
  vertical-align: middle;
  text-align: left;
  @include shadow(0, 0, 4px, 0.6);
  border: 0;
  background-color: white;
  border-radius: 3px;
  color: $hku-black;
  padding: 8px 10px;
  margin-bottom: 8px;
  font-size:15px;
  transition:0.1s linear;
  &:active,
  &:focus,
  &:hover {
    outline: 0;
    background-color: $hku-offwhite;
  }

  &.active {
    background-color: $hku-black;
    color: $hku-offwhite;
  }

  &:before {
    content:"";
    width:22px;
    height:22px;
    display: inline-block;
    margin-right:4px;
    vertical-align: text-bottom;
    background-repeat: no-repeat;
    background-image:url('../assets/mall-black.svg');
    background-size:100% auto;
    background-position: center bottom;

  }

  &#malls {
    &:before {
      background-image:url('../assets/mall-black.svg');
    }
    &.active:before {
      background-image:url('../assets/mall-white.svg');
    }
  }
  &#restaurants{
    &:before {
      background-image:url('../assets/restaurant-black.svg');
    }
    &.active:before {
      background-image:url('../assets/restaurant-white.svg');
    }
  }
  &#five_days{
    &:before {
      background-image:url('../assets/five-day-cases-black.svg');
    }
    &.active:before {
      background-image:url('../assets/five-day-cases-white.svg');
    }
  }
  &#distance {
    
    &:before {
      background-image:url('../assets/distance-black.svg');
    }
    &.active:before {
      background-image:url('../assets/distance-white.svg');
    }
  }
}

@media screen and (max-width: $breakpoint-tablet) { 
  .button {
    display: inline-block;
    margin: 0 4px 8px 0;
  }

}
</style>
